import { render } from "./AuthorizationDirector.vue?vue&type=template&id=64146416"
import script from "./AuthorizationDirector.vue?vue&type=script&lang=js"
export * from "./AuthorizationDirector.vue?vue&type=script&lang=js"

import exportComponent from "/Users/isaias/Developer/Trayectics/Trayectics-Questions/trayectics_questions/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__